import React from 'react';
import { InputBase } from '@material-ui/core';
import { LABEL_WIDTH } from '../wizard-ui/constants';

const EditablePillLabel: React.FC<{
    value: string;
    placeholder?: string;
    onChange: (v: string) => void;
    style?: React.CSSProperties;
}> = ({ value, placeholder = 'field name', onChange, style }) => (
    <InputBase
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={{
            width: LABEL_WIDTH,
            flexShrink: 0,
            padding: '7px 14px',
            border: '1px solid #b2dfd6',
            borderRadius: 8,
            background: '#e8f8f5',
            fontFamily: "'DM Mono', monospace",
            fontSize: 13,
            fontWeight: 500,
            color: '#1eb89a',
            boxSizing: 'border-box' as const,
            lineHeight: '20px',
            ...style
        }}
        inputProps={{ style: { padding: 0 } }}
    />
);

export default EditablePillLabel;
